import { application } from "./application"

import AddSponsorController from "./add_sponsor_controller"
import AskSavantController from "./ask_savant_controller"
import AutocompleteController from "./autocomplete_controller"
import BoardLayoutController from "./board_layout_controller"
import BulkSelectController from "./bulk_select_controller"
import ClipboardController from "./clipboard_controller"
import ClockController from "./clock_controller"
import CommandPaletteController from "./command_palette_controller"
import DetailsMemoryController from "./details_memory_controller"
import DownloadButtonController from "./download_button_controller"
import EmailThreadController from "./email_thread_controller"
import DropdownPopoverController from "./dropdown_popover_controller"
import EndTimeController from "./end_time_controller"
import GuestTimezoneController from "./guest_timezone_controller"
import KanbanController from "./kanban_controller"
import ModalController from "./modal_controller"
import PullToRefreshController from "./pull_to_refresh_controller"
import PwaController from "./pwa_controller"
import QueueStatusController from "./queue_status_controller"
import ScrollToTodayController from "./scroll_to_today_controller"
import SidebarController from "./sidebar_controller"
import SignaturePadController from "./signature_pad_controller"
import SlideoverController from "./slideover_controller"
import StepperController from "./stepper_controller"
import StickyNoteController from "./sticky_note_controller"
import SwDeviceCodeController from "./sw_device_code_controller"
import TabsController from "./tabs_controller"
import TaskReviewController from "./task_review_controller"
import TiptapEditorController from "./tiptap_editor_controller"
import ToastController from "./toast_controller"
import TerminalController from "./terminal_controller"

application.register("add-sponsor", AddSponsorController)
application.register("ask-savant", AskSavantController)
application.register("autocomplete", AutocompleteController)
application.register("board-layout", BoardLayoutController)
application.register("bulk-select", BulkSelectController)
application.register("clipboard", ClipboardController)
application.register("clock", ClockController)
application.register("command-palette", CommandPaletteController)
application.register("details-memory", DetailsMemoryController)
application.register("download-button", DownloadButtonController)
application.register("email-thread", EmailThreadController)
application.register("dropdown-popover", DropdownPopoverController)
application.register("end-time", EndTimeController)
application.register("guest-timezone", GuestTimezoneController)
application.register("kanban", KanbanController)
application.register("modal", ModalController)
application.register("pull-to-refresh", PullToRefreshController)
application.register("pwa", PwaController)
application.register("queue-status", QueueStatusController)
application.register("scroll-to-today", ScrollToTodayController)
application.register("sidebar", SidebarController)
application.register("signature-pad", SignaturePadController)
application.register("slideover", SlideoverController)
application.register("stepper", StepperController)
application.register("sticky-note", StickyNoteController)
application.register("sw-device-code", SwDeviceCodeController)
application.register("tabs", TabsController)
application.register("task-review", TaskReviewController)
application.register("tiptap-editor", TiptapEditorController)
application.register("toast", ToastController)
application.register("terminal", TerminalController)
